import React, { useEffect, useState } from "react";
import { CiCreditCard1 } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { baseURL } from "../../utils/config";
import Card from "../../components/global/Card";
import { Button } from "antd";
import CustomScrollbar from "../../components/global/CustomScrollBar";
import Pricing from "../../components/Pricing";
import { updateTitleData } from "../../stores/slices/userAuthSlice";
import { api } from "../../components/global/api";

const BilingPage = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);
  const currentPlan = user?.currentPlan;
  const currentUser = user?.currentUser;
  const [loading, setLoading] = useState(false);

  const currentEmployee = currentUser?.employees[user?.currentCompany];
  const roleName = currentEmployee?.rolename;

  const upgradePlan = async ({ price_id }) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("user_id", currentPlan?.user_id);
      const res = await api.post(`${baseURL}/create-customer-portal-session/`, {
        user_id: currentPlan?.user_id,
        price_id: price_id,
        company_id: currentEmployee?.company_id,
      });
      const data = res?.data;
      window.location.href = data?.url;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      updateTitleData({
        title: "Billing",
        ClickLink: null,
      })
    );
  }, []);

  const IsFreeNow =
    currentPlan?.plan_name === "Free" || currentPlan?.free_trial_status;

  return (
    <div className="p-4 h-full bg-white rounded-lg overflow-y-auto">
      <CustomScrollbar>
        <div className="w-full p-2 flex flex-col gap-y-4">
          {!IsFreeNow && (
            <div className="flex gap-4">
              <Card
                icon={
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="0.5"
                      width="24.2105"
                      height="23"
                      rx="4.84211"
                      fill="#CEFFDF"
                    />
                    <path
                      d="M11.4148 15.0082L16.7582 10.2206L15.4105 9.01308L11.4148 12.5932L9.4288 10.8137L8.08114 12.0212L11.4148 15.0082ZM12.4078 20.4737C10.2169 19.9794 8.40837 18.853 6.98221 17.0944C5.55606 15.3359 4.84267 13.3835 4.84204 11.2374V6.06847L12.4078 3.52637L19.9736 6.06847V11.2374C19.9736 13.3841 19.2605 15.3367 17.8344 17.0953C16.4082 18.8539 14.5994 19.98 12.4078 20.4737ZM12.4078 18.6943C14.0471 18.2282 15.4026 17.2961 16.4744 15.8979C17.5463 14.4998 18.0822 12.9463 18.0822 11.2374V7.2336L12.4078 5.32703L6.73349 7.2336V11.2374C6.73349 12.9463 7.2694 14.4998 8.34122 15.8979C9.41304 17.2961 10.7686 18.2282 12.4078 18.6943Z"
                      fill="#17D556"
                    />
                  </svg>
                }
                title={
                  currentPlan?.plan_name ||
                  currentPlan?.subscription?.plan_name ||
                  currentUser?.plan_name
                }
                desc={"Current Plan"}
                price="10"
                color={"#DAF5E2"}
                textcolor={"#049133"}
              />
              <Card
                icon={
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="0.5"
                      width="25"
                      height="24"
                      rx="4"
                      fill="#E2ECFF"
                    />
                    <path
                      d="M10.2962 7.9997C10.2962 7.40356 10.5284 6.83184 10.9417 6.4103C11.3549 5.98877 11.9154 5.75195 12.4999 5.75195C13.0843 5.75195 13.6448 5.98877 14.0581 6.4103C14.4714 6.83184 14.7036 7.40356 14.7036 7.9997C14.7036 8.59584 14.4714 9.16757 14.0581 9.5891C13.6448 10.0106 13.0843 10.2475 12.4999 10.2475C11.9154 10.2475 11.3549 10.0106 10.9417 9.5891C10.5284 9.16757 10.2962 8.59584 10.2962 7.9997ZM12.4999 6.87695C12.3553 6.87695 12.2122 6.90599 12.0787 6.96242C11.9451 7.01884 11.8238 7.10154 11.7215 7.2058C11.6193 7.31006 11.5383 7.43383 11.4829 7.57005C11.4276 7.70626 11.3991 7.85226 11.3991 7.9997C11.3991 8.14714 11.4276 8.29314 11.4829 8.42936C11.5383 8.56558 11.6193 8.68935 11.7215 8.79361C11.8238 8.89786 11.9451 8.98057 12.0787 9.03699C12.2122 9.09341 12.3553 9.12245 12.4999 9.12245C12.7918 9.12245 13.0718 9.00416 13.2782 8.79361C13.4846 8.58305 13.6006 8.29747 13.6006 7.9997C13.6006 7.70193 13.4846 7.41636 13.2782 7.2058C13.0718 6.99524 12.7918 6.87695 12.4999 6.87695ZM15.8087 8.5622C15.8087 8.3406 15.8515 8.12116 15.9346 7.91642C16.0178 7.71169 16.1396 7.52566 16.2933 7.36896C16.4469 7.21226 16.6293 7.08796 16.83 7.00316C17.0307 6.91835 17.2459 6.8747 17.4631 6.8747C17.6804 6.8747 17.8955 6.91835 18.0962 7.00316C18.297 7.08796 18.4793 7.21226 18.633 7.36896C18.7866 7.52566 18.9085 7.71169 18.9916 7.91642C19.0747 8.12116 19.1175 8.3406 19.1175 8.5622C19.1175 9.00976 18.9432 9.43898 18.633 9.75545C18.3227 10.0719 17.9019 10.2497 17.4631 10.2497C17.0243 10.2497 16.6035 10.0719 16.2933 9.75545C15.983 9.43898 15.8087 9.00976 15.8087 8.5622ZM17.4631 7.9997C17.3169 7.9997 17.1766 8.05897 17.0732 8.16446C16.9698 8.26994 16.9116 8.41302 16.9116 8.5622C16.9116 8.71139 16.9698 8.85446 17.0732 8.95995C17.1766 9.06544 17.3169 9.1247 17.4631 9.1247C17.6094 9.1247 17.7496 9.06544 17.8531 8.95995C17.9565 8.85446 18.0146 8.71139 18.0146 8.5622C18.0146 8.41302 17.9565 8.26994 17.8531 8.16446C17.7496 8.05897 17.6094 7.9997 17.4631 7.9997ZM7.53665 6.8747C7.09787 6.8747 6.67707 7.05249 6.3668 7.36896C6.05654 7.68543 5.88224 8.11465 5.88224 8.5622C5.88224 9.00976 6.05654 9.43898 6.3668 9.75545C6.67707 10.0719 7.09787 10.2497 7.53665 10.2497C7.97543 10.2497 8.39623 10.0719 8.7065 9.75545C9.01676 9.43898 9.19106 9.00976 9.19106 8.5622C9.19106 8.11465 9.01676 7.68543 8.7065 7.36896C8.39623 7.05249 7.97543 6.8747 7.53665 6.8747ZM6.98518 8.5622C6.98518 8.41302 7.04328 8.26994 7.1467 8.16446C7.25012 8.05897 7.39039 7.9997 7.53665 7.9997C7.68291 7.9997 7.82318 8.05897 7.9266 8.16446C8.03002 8.26994 8.08812 8.41302 8.08812 8.5622C8.08812 8.71139 8.03002 8.85446 7.9266 8.95995C7.82318 9.06544 7.68291 9.1247 7.53665 9.1247C7.39039 9.1247 7.25012 9.06544 7.1467 8.95995C7.04328 8.85446 6.98518 8.71139 6.98518 8.5622ZM8.38371 11.3747C8.19008 11.7167 8.08814 12.1047 8.08812 12.4997H5.88224V15.3122C5.88215 15.592 5.95028 15.8675 6.08051 16.1138C6.21074 16.3601 6.39897 16.5695 6.62825 16.7231C6.85754 16.8768 7.12069 16.9698 7.39401 16.994C7.66733 17.0181 7.94225 16.9725 8.194 16.8613C8.27562 17.2337 8.40356 17.5892 8.569 17.9211C8.1504 18.0935 7.6967 18.1584 7.24774 18.1102C6.79879 18.0619 6.36831 17.902 5.99412 17.6444C5.61993 17.3868 5.31347 17.0394 5.10166 16.6328C4.88984 16.2261 4.77915 15.7727 4.7793 15.3122V12.4997C4.7793 12.2013 4.8955 11.9152 5.10234 11.7042C5.30918 11.4932 5.58972 11.3747 5.88224 11.3747H8.38371ZM16.4308 17.9211C16.8494 18.0935 17.3031 18.1584 17.752 18.1102C18.201 18.0619 18.6315 17.902 19.0056 17.6444C19.3798 17.3868 19.6863 17.0394 19.8981 16.6328C20.1099 16.2261 20.2206 15.7727 20.2205 15.3122V12.4997C20.2205 12.2013 20.1043 11.9152 19.8974 11.7042C19.6906 11.4932 19.4101 11.3747 19.1175 11.3747H16.6161C16.8036 11.7055 16.9116 12.0891 16.9116 12.4997H19.1175V15.3122C19.1176 15.592 19.0495 15.8675 18.9193 16.1138C18.789 16.3601 18.6008 16.5695 18.3715 16.7231C18.1422 16.8768 17.8791 16.9698 17.6058 16.994C17.3324 17.0181 17.0575 16.9725 16.8058 16.8613C16.7219 17.2348 16.5969 17.5881 16.4308 17.9211ZM10.294 11.3736C10.0015 11.3736 9.72095 11.4921 9.51411 11.7031C9.30726 11.9141 9.19106 12.2002 9.19106 12.4986V15.8747C9.19106 16.7698 9.53967 17.6283 10.1602 18.2612C10.7807 18.8941 11.6223 19.2497 12.4999 19.2497C13.3774 19.2497 14.2191 18.8941 14.8396 18.2612C15.4601 17.6283 15.8087 16.7698 15.8087 15.8747V12.4997C15.8087 12.2013 15.6925 11.9152 15.4857 11.7042C15.2788 11.4932 14.9983 11.3747 14.7058 11.3747L10.294 11.3736ZM10.294 12.4986H14.7058V15.8747C14.7058 16.4714 14.4734 17.0437 14.0597 17.4657C13.646 17.8876 13.0849 18.1247 12.4999 18.1247C11.9148 18.1247 11.3538 17.8876 10.9401 17.4657C10.5264 17.0437 10.294 16.4714 10.294 15.8747V12.4986Z"
                      fill="#5B90F0"
                    />
                  </svg>
                }
                title={
                  currentPlan?.remaining_team_members === -1
                    ? "Unlimited"
                    : Math.max(currentPlan?.remaining_team_members, 0)
                }
                desc={"Remaining Team Members"}
                price="10"
                color={"blue.100"}
              />
            </div>
          )}
          {!IsFreeNow && roleName === "Admin" && (
            <div
              className="w-full border justify-center items-center  flex p-4 rounded-2xl gap-x-2 "
              style={{
                border: "2px #C6D6F6 solid",
              }}
            >
              <img
                src="/assets/images/bill.png"
                alt="billing"
                className="col-span-2  rounded items-start w-48 h-48"
              />
              <div className="col-span-8 p-4">
                <h1 className="text-xl font-semibold">Manage your billing</h1>
                <p>
                  You are currently on the{" "}
                  {currentPlan?.plan_name ||
                    currentPlan?.subscription?.plan_name ||
                    currentUser?.plan_name}{" "}
                  . Access our billing portal to modify your plan, update
                  payment methods, download invoices, or cancel your
                  subscription.
                </p>
                <div className="flex mt-5">
                  <Button
                    className="col-span-2  py-2 px-4 rounded-full flex items-center gap-x-2 w-max"
                    onClick={upgradePlan}
                    loading={loading}
                    style={{
                      border: "1px #49B0DF solid",
                      backgroundColor: "#DEE9FF",
                      color: "#096C9D",
                    }}
                  >
                    <CiCreditCard1
                      className=""
                      style={{
                        color: "#096C9D",
                      }}
                    />
                    Manage Billing
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>{" "}
        {IsFreeNow && (
          <div className="flex flex-col gap-y-2 overflow-x-hidden">
            <h2 className="text-3xl text-center">Choose Your Perfect Plan</h2>
            <p className="text-center">
              Choose a plan that best fits your needs. You can upgrade or
              downgrade at any time.
            </p>
            <p className="text-center text-orange-500 ">
              * 14-Days free trial !
            </p>
            <Pricing widthNew="true" handleClick={upgradePlan} />
          </div>
        )}
      </CustomScrollbar>
    </div>
  );
};

export default BilingPage;
